import { render, staticRenderFns } from "./NewWeightTracking.vue?vue&type=template&id=580b44a1&"
import script from "./NewWeightTracking.vue?vue&type=script&lang=js&"
export * from "./NewWeightTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports